import { territorialAuthorityExtension } from '@/features/profile-setting/components/organization-extensions/territorial-authority';
import { TerritorialAuthorityCreateSection } from '@/features/profile-setting/components/organization-extensions/territorial-authority/TerritorialAuthorityCreateSection';
import { TerritorialAuthorityEditSection } from '@/features/profile-setting/components/organization-extensions/territorial-authority/TerritorialAuthorityEditSection';
import type { OrganizationExtension } from '@/features/profile-setting/components/organization-extensions/types';

export const territorialAuthorityExtensionWithSections: OrganizationExtension<'territorialAuthority'> =
  {
    ...territorialAuthorityExtension,
    CreateSection: TerritorialAuthorityCreateSection,
    EditSection: TerritorialAuthorityEditSection
  };
